import { addons } from "@storybook/manager-api";
import theme from "./HCLTheme";

addons.setConfig({
    theme
});